import { UniqueReport } from './unique-report';

export class AverageReport {
    constructor(
      public filteredPollReports?: UniqueReport[],
      public filteredCompaniesPollReports?: UniqueReport[]
    ) { }

    clone() {
      return new AverageReport(
        this.filteredPollReports,
        this.filteredCompaniesPollReports
      );
    }
  }

